/**
 * Logo — the Kaspyan Nexus compass mark, the single in-app source of truth so
 * the header / login / loading / anywhere all render the SAME mark and can't
 * drift (2026-06-20). Geometry matches public/favicon.svg + public/nexus-logo-
 * mark.svg: a solid-bold compass with a soft-gold (#CCA468) "operator node".
 *
 * `mono` renders it all-white (for the teal Login panel / dark surfaces).
 */
export function Logo({ className = 'w-8 h-8', mono = false }: { className?: string; mono?: boolean }) {
  const teal = mono ? '#ffffff' : '#0D9488';
  const gold = mono ? '#ffffff' : '#CCA468';
  return (
    <svg viewBox="-100 -100 200 200" className={className} role="img" aria-label="Kaspyan Nexus" fill="none">
      <circle cx="0" cy="0" r="90" fill="none" stroke={teal} strokeWidth="5" opacity={mono ? 0.7 : 0.55} />
      <polygon points="0,-82 17,-60 0,-38 -17,-60" fill={teal} />
      <polygon points="0,38 17,60 0,82 -17,60" fill={teal} />
      <polygon points="60,-12 78,0 60,12 42,0" fill={teal} />
      <polygon points="-60,-12 -42,0 -60,12 -78,0" fill={teal} />
      <polygon points="0,-30 30,0 0,30 -30,0" fill={gold} />
      <polygon points="0,-13 13,0 0,13 -13,0" fill="#0D9488" />
    </svg>
  );
}
